import clsx from 'clsx';
import styles from './SkeletonCell.module.scss';

interface SkeletonCellProps {
    className?: string;
    style?: React.CSSProperties;
    'data-testid'?: string;
}

export default function SkeletonCell({
    className = '',
    style = {},
    'data-testid': dataTestId = 'classification-skeleton',
}: SkeletonCellProps) {
    return <div data-testid={dataTestId} className={clsx(styles.skeletonCell, className)} style={style} />;
}
